import lazy from '@riotjs/lazy'
import { Router, Route } from '@riotjs/route'
import Loader from './Loader.riot'

export default {
  'css': `app,[is="app"]{ font-family: Helvetica Neue, Helvetica, Arial; } app ul,[is="app"] ul{ display: flex; list-style: none; padding: 0; margin: 0; } app ul li a,[is="app"] ul li a{ padding: 16px; }`,

  'exports': {
    isActive(path){
      return window.location.pathname == path
    },

    components: {
      Router,
      Route,
      Counter: lazy(Loader, () => import('./Counter.riot')),
      Books: lazy(Loader, () => import('./Books.riot')),
      Home: lazy(Loader, () => import('./Home.riot')),
      Contact: lazy(Loader, ()=> import('./Contact.riot')),
      Loader: Loader,
    }
  },

  'template': function(template, expressionTypes, bindingTypes, getComponent) {
    return template(
      '<aside class="relative bg-sidebar h-screen w-64 hidden sm:block shadow-xl"><div class="p-6"><a href="/" class="text-white text-3xl font-semibold uppercase hover:text-gray-300">Riot Wasm</a></div><nav class="text-white text-base font-semibold pt-3"><a href="/" class="flex items-center text-white py-4 pl-6 nav-item"><i class="fas fa-tachometer-alt mr-3"></i>\n                Home\n            </a><a href="/books" class="flex items-center text-white hover:opacity-100 py-4 pl-6 nav-item"><i class="fas fa-sticky-note mr-3"></i>\n                Books\n            </a><a href="/counter" class="flex items-center text-white  hover:opacity-100 py-4 pl-6 nav-item"><i class="fas fa-table mr-3"></i>\n                Counter\n            </a><a href="/form" class="flex items-center text-white hover:opacity-100 py-4 pl-6 nav-item"><i class="fas fa-align-left mr-3"></i>\n                Post\n            </a></nav><a href="https://github.com/geofmureithi/riot-rs-wasm" class="absolute w-full upgrade-btn bottom-0 active-nav-link text-white flex items-center justify-center py-4"><i class="fas fa-arrow-circle-up mr-3"></i>\n             See on Github\n        </a></aside><div class="relative w-full flex flex-col h-screen overflow-y-hidden"><div class="w-full h-screen overflow-x-hidden border-t flex flex-col"><main class="w-full flex-grow p-6"><router expr0="expr0"></router></main><footer class="w-full bg-white text-right p-4">\n                Copyleft <a target="_blank" href="https://mureithi.me" class="underline">Njuguna Mureithi</a> | Theme by <a target="_blank" href="https://davidgrzyb.com" class="underline">David Grzyb</a>.\n            </footer></div></div>',
      [{
        'type': bindingTypes.TAG,
        'getComponent': getComponent,

        'evaluate': function(scope) {
          return 'router';
        },

        'slots': [{
          'id': 'default',
          'html': '<route expr1="expr1" path="/"></route><route expr3="expr3" path="/form"></route><route expr5="expr5" path="/counter"></route><route expr7="expr7" path="/books"></route>',

          'bindings': [{
            'type': bindingTypes.TAG,
            'getComponent': getComponent,

            'evaluate': function(scope) {
              return 'route';
            },

            'slots': [{
              'id': 'default',
              'html': '<home expr2="expr2"></home>',

              'bindings': [{
                'type': bindingTypes.TAG,
                'getComponent': getComponent,

                'evaluate': function(scope) {
                  return 'home';
                },

                'slots': [],
                'attributes': [],
                'redundantAttribute': 'expr2',
                'selector': '[expr2]'
              }]
            }],

            'attributes': [],
            'redundantAttribute': 'expr1',
            'selector': '[expr1]'
          }, {
            'type': bindingTypes.TAG,
            'getComponent': getComponent,

            'evaluate': function(scope) {
              return 'route';
            },

            'slots': [{
              'id': 'default',
              'html': '<contact expr4="expr4"></contact>',

              'bindings': [{
                'type': bindingTypes.TAG,
                'getComponent': getComponent,

                'evaluate': function(scope) {
                  return 'contact';
                },

                'slots': [],
                'attributes': [],
                'redundantAttribute': 'expr4',
                'selector': '[expr4]'
              }]
            }],

            'attributes': [],
            'redundantAttribute': 'expr3',
            'selector': '[expr3]'
          }, {
            'type': bindingTypes.TAG,
            'getComponent': getComponent,

            'evaluate': function(scope) {
              return 'route';
            },

            'slots': [{
              'id': 'default',
              'html': '<counter expr6="expr6"></counter>',

              'bindings': [{
                'type': bindingTypes.TAG,
                'getComponent': getComponent,

                'evaluate': function(scope) {
                  return 'counter';
                },

                'slots': [],
                'attributes': [],
                'redundantAttribute': 'expr6',
                'selector': '[expr6]'
              }]
            }],

            'attributes': [],
            'redundantAttribute': 'expr5',
            'selector': '[expr5]'
          }, {
            'type': bindingTypes.TAG,
            'getComponent': getComponent,

            'evaluate': function(scope) {
              return 'route';
            },

            'slots': [{
              'id': 'default',
              'html': '<books expr8="expr8"></books>',

              'bindings': [{
                'type': bindingTypes.TAG,
                'getComponent': getComponent,

                'evaluate': function(scope) {
                  return 'books';
                },

                'slots': [],
                'attributes': [],
                'redundantAttribute': 'expr8',
                'selector': '[expr8]'
              }]
            }],

            'attributes': [],
            'redundantAttribute': 'expr7',
            'selector': '[expr7]'
          }]
        }],

        'attributes': [],
        'redundantAttribute': 'expr0',
        'selector': '[expr0]'
      }]
    );
  },

  'name': 'app'
};